/**
 * Restores the Maasz checkout consent gate for cart drawer and cart page.
 * The gate remains scoped to its own terms-checkbox instance.
 */
if (!customElements.get('terms-checkbox')) {
  class TermsCheckbox extends HTMLElement {
    connectedCallback() {
      const append = this.dataset.append || '';
      const checkbox = this.querySelector(`#CartTerms${append}`);
      if (!checkbox) return;

      const root = this.closest('cart-drawer') || this.closest('.thb-cart-collaterals') || document;
      const gateWraps = root.querySelectorAll('[data-terms-gate-wrap], .terms-gate-wrap');
      const gateOverlays = root.querySelectorAll('[data-terms-gate-overlay]');
      const checkoutButton = this.parentElement && this.parentElement.querySelector('.button.checkout-button');

      const showError = () => {
        this.classList.remove('has-error', 'blink-error');
        void this.offsetWidth;
        this.classList.add('has-error', 'blink-error');
        checkbox.focus();
      };
      const updateGate = () => {
        gateWraps.forEach((gateWrap) => {
          gateWrap.classList.toggle('is-unlocked', checkbox.checked);
          gateWrap.classList.toggle('is-locked', !checkbox.checked);
        });
        checkbox.setCustomValidity(checkbox.checked ? '' : ((window.theme && theme.strings && theme.strings.requiresTerms) || ''));
        if (checkbox.checked) this.classList.remove('has-error', 'blink-error');
      };

      gateOverlays.forEach((overlay) => {
        overlay.addEventListener('click', (event) => {
          if (checkbox.checked) return;
          event.preventDefault();
          event.stopPropagation();
          showError();
        }, true);
      });
      if (checkoutButton) {
        checkoutButton.addEventListener('click', (event) => {
          if (checkbox.checked) return;
          event.preventDefault();
          showError();
          checkbox.reportValidity();
        });
      }
      checkbox.addEventListener('change', updateGate);
      updateGate();
    }
  }
  customElements.define('terms-checkbox', TermsCheckbox);
}